import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    _id: '',
    avatar: '',
    userName: '',
    email: '',
    phone: '',
    userType: '',
    authority: [],
    profile: {
        firstName: '',
        lastName: '',
    },
    notificationPreferences: {
        salesAndNews: true,
        itemsILike: true,
        myListing: true,
        peopleIFollow: true,
    },
    emailVerified: false,
    isActive: false,
    verified: false,
    averageRating: 0,
    lastLogin: null,
    createdAt: null,
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
    },
})

export const { setUser, userLoggedOut } = userSlice.actions

export default userSlice.reducer
